import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { EquipmentCountingJournalListComponent } from './equipment-counting-journal-list/equipment-counting-journal-list.component';

const routes: Routes = [
  {
    path: '',
    component: EquipmentCountingJournalListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EquipmentCountingJournalRoutingModule {}
